// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__DQczl","loader":"Loader_loader__v4pph","spin":"Loader_spin__3Dwek"};